import { Component, inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { AgPrintComponent } from '../ag-print/ag-print.component';
import { PershingPrintComponent } from '../pershing-print/pershing-print.component';

@Component({
  selector: 'app-custom-report-modal',
  templateUrl: './custom-report-modal.component.html',
  styleUrls: ['./custom-report-modal.component.scss'],
  imports: [AgPrintComponent, PershingPrintComponent, MatDialogModule],
})
export class CustomReportModalComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<CustomReportModalComponent>>(MatDialogRef);

  closeModal(ev) {
    this.dialogRef.close(ev);
  }
}
